export type SelectValue = { value?: string; label?: string }

export enum FilterPage {
  MAIN,
  LANGUAGES,
  SELECTED_LANGUAGES,
  TIME_DURATION,
}
